module.exports = __webpack_public_path__ + "static/home-illustration-2-9e4a1cf033db0bb7533fe50f770131d7.svg";